import { useApiStore } from "@/stores/api/index.ts";

const searchSiteSwitcherSites = async (module, searchQuery) => {
  const api = useApiStore();
  const { commit, getters } = module;

  commit("storeSiteSwitcherSites", []);

  if (!searchQuery) {
    return getters.siteSwitcherSites();
  }

  const results = await api.getSites(searchQuery.toLowerCase().trim());

  commit("storeSiteSwitcherSites", results.data.sites);

  return getters.siteSwitcherSites();
};

export { searchSiteSwitcherSites };
